<template>
  <el-select
    :value="value"
    size="small"
    filterable
    remote
    clearable
    @change="handleChange"
    :remote-method="requestData"
    :loading="loading"
    placeholder="搜索并选择"
    style="width: 100%"
    :popper-append-to-body="true"
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="`${item.code}（${item.name}）`"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>

<script>
import { itemList } from '@/service/getData'

export default {
  props: {
    value: '',
    category: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      lists: [],
      loading: false,
    }
  },
  created() {
    if (this.value) {
      this.requestData('default')
    }
  },
  methods: {
    handleChange(e) {
      this.$emit('input', e)
    },
    async requestData(query) {
      if (query !== '') {
        this.loading = true
        let data = {
          code: query == 'default' ? '' : query,
          category: this.category,
          id: query == 'default' ? this.value : 0,
          select_option: true,
        }

        let res = await itemList(data)
        this.loading = false
        this.lists = res.data.list
      } else {
        this.lists = []
      }
    },
  },
}
</script>